import React from "react";
import { NewDate } from "../../../../../components/history-list/history-list";

const Events = ({ newTraining }) => {
  const { history } = newTraining;
  return (
    <>
      {history.length > 0 ? (
        history.map((item) => (
          <div className="trainingEventsContainer" key={item.id}>
            <h6>{item.content}</h6>
            <div className="trainingEventsContainerFooter">
              <span>{item.creator}</span>
              <span>
                <NewDate created_at={item.created_at} />
              </span>
            </div>
          </div>
        ))
      ) : (
        <h3 className="ArrayEmpty">Нет событий</h3>
      )}
    </>
  );
};

export default Events;
